import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NavigationContainerComponent } from '../navigation-container/navigation-container.component';
import { HeaderComponent } from '@app/partials/header/header.component';
import { NotificationComponent } from '@app/shared/notification/notification.component';

@Component({
  selector: 'app-app-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet, 
    NavigationContainerComponent, 
    HeaderComponent, 
    NotificationComponent
  ],
  templateUrl: './app-layout.component.html',
  styles: ``
})
export class AppLayoutComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  
  isMobile = false;
  
  ngOnInit() {
    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe(result => {
        this.isMobile = result.matches;
      });
  }
}
